"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'tabs';
const Tabs = (props) => {
    var _a;
    const { selectedId, select, tabs, modificators, disabled } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__header` },
            react_1.default.createElement("div", { className: `${className}__nav` }, tabs.map((tab) => (react_1.default.createElement("button", { key: tab.id, type: 'button', onClick: () => {
                    select(tab.id);
                }, disabled: disabled, className: (0, classFunctions_1.getClassNames)(`${className}__nav-item`, [
                    selectedId === tab.id ? 'active' : undefined,
                    disabled ? 'disabled' : undefined,
                    tab.hasError ? 'has-error' : undefined,
                ]) }, tab.title))))),
        react_1.default.createElement("div", { className: `${className}__content` }, (_a = tabs.find(x => x.id === selectedId)) === null || _a === void 0 ? void 0 : _a.content)));
};
exports.Tabs = Tabs;
//# sourceMappingURL=index.js.map